import React, { useRef } from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { useStore } from 'core/store/';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { NEW_CUSTOMER_HOME_SECURITY } from 'core/helpers/constants';
import { ConnectedHomeForm } from 'offer/components/sidebar/components/discounts-card/connected-home-discount/connected-home-form';

import useStyles from './connected-home-discount-modal.styles';

const ConnectedHomeDiscountModal = observer(() => {
  const classes = useStyles();

  const { offer } = useStore();
  const { setIncludeConnectedHome, setShowConnectedHomeModal } = offer;

  const { values, setFieldValue } = useFormikContext();
  const connectedHomeRef = useRef(values.connectedHome);

  const onClose = () => {
    // if user did not fill in provider name, then form is likely not filled in
    if (values.connectedHome.providerName === undefined) {
      // clear the form, set connectedHome to null
      setFieldValue('connectedHome', null);
      setFieldValue('global.homeSecurityPartnerCustomerType', NEW_CUSTOMER_HOME_SECURITY.NO_SIGN_UP_TYPE);
      setIncludeConnectedHome(false);
    } else if (connectedHomeRef.current.providerName) {
      // reset to last saved values
      setFieldValue('connectedHome', connectedHomeRef.current);
    }
    setShowConnectedHomeModal(false);
  };

  return (
    <BaseDialog onClose={onClose} open>
      <Label marginBottom={5} type="modalTitle">
        Connected Home Discount
      </Label>
      <Label type="greenSmall" className={classes.description}>
        This dwelling policy discount is available to applicants whose homes are professionally monitored by a home
        security system. After purchase, members have 15 days to submit proof of their home security provider to retain
        the discount.
      </Label>
      <ConnectedHomeForm mode="light" />
    </BaseDialog>
  );
});

export default ConnectedHomeDiscountModal;
